"use client";

// css
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "@/shared/admin/styles/nextjs.scss";
import "@/app/styles/admin/style.css";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  // return (
  //   <div className="error">
  //     <div className="error-code"> 500 </div>
  //     <div className="error-content">
  //       <div className="error-message"> 에러가 발생했습니다. </div>
  //       <div className="error-desc mb-4">{error.message || '서버에서 오류가 발생했습니다.'}</div>
  //       <div>
  //         <a href="/app/main" className="btn btn-success px-3">
  //           홈으로 이동
  //         </a>
  //       </div>
  //     </div>
  //   </div>
  // );

  return (
    <div className="error">
      <div className="error-code">404</div>
      <div className="error-content">
        <div className="error-message">페이지를 찾을 수 없습니다.</div>
        <div className="error-desc mb-4">
          요청하신 페이지를 찾을 수 없습니다. <br />
          홈으로 이동하여 다시 시도해 주세요.
        </div>
        <div>
          <a href="/app/main" className="btn btn-success px-3">
            홈으로 이동
          </a>
        </div>
      </div>
    </div>
  );
}
